module.exports = __webpack_public_path__ + "static/media/NSS5.07544f8b.jpg";